import React from 'react';
import CardLoader from 'wrapper/card-loader';

const B2CLoginBadge = ({ userName }) => {
  const displayName = userName || 'there';

  return (
    <CardLoader
      message={`Welcome back, ${displayName}. Preparing your dashboard…`}
    />
  );
};

export default B2CLoginBadge;
